export default {
  init() {
    googleMapsInitializer();

    let availabilitySubmit = document.querySelector("#availabilitySubmit");
    if (availabilitySubmit) {
      availabilitySubmit.addEventListener("click", event => {
        let nights = document.querySelector("#nights");
        let date = document.querySelector("#date");
        let guests = document.querySelector("#guests"); // Cant be applied to search url - no such param as guests
        window.open(
          `https://portal.freetobook.com/reservations?w_id=3132&w_tkn=0QSfvbCL4xFjHQVpHCwgAPy8kamxHC4xWGsddQsZaoAsjTzNJN3uORDje6eVW&checkIn=${
            date.value
          }&stayLength=${nights.value}`
        );
      });
    }

    /*let toggler = document.getElementById("toggler");
    if (toggler) {
      toggler.addEventListener("click", () => {
        document.getElementById("sidenav").classList.toggle("opened");
        document.getElementById("main").classList.toggle("opened");
      });
    }*/

    window.onscroll = event => {
      if (event.srcElement.baseURI == "https://www.balquhidderbraes.co.uk/") {
        let widget = document.getElementById("collapseAvailability");
        let widgetButton = document.querySelector("button.availability__button");
        if (widget) {
          widget.classList.contains("show") ? widgetButton.click() : null;
        }
      }
    };

    $('#toggler').on('click', function(){
      $('#sidenav').stop().toggleClass('reset-right');
      $('#main').stop().toggleClass('dimmed');
      if($('body').hasClass('mobile-nav')){
        $('body').removeClass('mobile-nav');
      }else{
        $('body').addClass('mobile-nav');
      }
    });

    $('#main').on('click', function(){
      $('body').removeClass('mobile-nav');
      $('#sidenav').stop().removeClass('reset-right');
      $(this).stop().removeClass('dimmed');
    });

    // Close mobile nav when clicking off
    /*$(document).mouseup(function(e){
      var menu = $('#sidenav');
      var btn = $('#toggler');
      var wrap = $('#main');
      if (!menu.is(e.target) // The target of the click isn't the container.
          || btn.is(e.target) // target #toggler.
          && menu.has(e.target).length === 0) // Nor a child element of the container
      {
        menu.removeClass('reset-right');
        wrap.removeClass('dimmed');
      }
    });*/

    // Remove .dimmed from wrap, close menu
    $(window).on('resize', function() {
      if($(window).innerWidth() > 991){
        $('body').removeClass('mobile-nav');
        $('#sidenav').removeClass('reset-right');
        $('#main').removeClass('dimmed');
      }
    });

    // Close availability on mobile
    if($(window).innerWidth() < 768){
      $('.availability__button').addClass('collapsed');
      $('.availability__button').attr('aria-expaned', 'false');
      $('#collapseAvailability').removeClass('show');
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};

function googleMapsInitializer() {
  (function($) {
    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */

    function new_map($el) {
      // var
      var $markers = $el.find(".marker");

      // vars
      var args = {
        zoom: 12,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          }
        ]
      };

      // create map
      var map = new google.maps.Map($el[0], args);

      // add a markers reference
      map.markers = [];

      // add markers
      $markers.each(function() {
        add_marker($(this), map);
      });

      // center map
      center_map(map);

      map.panBy(0, -100);

      // return
      return map;
    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */
    const map_object = window.map_object;
    var overlay_address = map_object.overlay_address;

    function add_marker($marker, map) {
      // var
      var latlng = new google.maps.LatLng($marker.attr("data-lat"), $marker.attr("data-lng"));

      // create marker
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: "/wp-content/themes/balquhidder-braes/dist/images/ellipse.png"
      });

      // add to array
      map.markers.push(marker);

      let content = overlay_address;

      // if marker contains HTML, add it to an infoWindow
      if (true) {
        // create info window
        var infowindow = new google.maps.InfoWindow({
          content: content
        });

        // Open info window by default
        infowindow.open(map, marker);
        // show info window when marker is clicked
        google.maps.event.addListener(marker, "click", function() {
          infowindow.open(map, marker);
        });
      }
    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function center_map(map) {
      // vars
      var bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each(map.markers, function(i, marker) {
        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);
      });

      // only 1 marker?
      if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(15);
      } else {
        // fit to bounds
        map.fitBounds(bounds);
      }
    }

    /*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	5.0.0
     *
     *  @param	n/a
     *  @return	n/a
     */
    // global var
    var map = null;

    $(document).ready(function() {
      $(".acf-map").each(function() {
        // create map
        map = new_map($(this));
      });
    });
  })(jQuery);
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js